<template>
<div id="contents">
     <!-- 头部组件 -->
     <component :is="header_"></component>
     <!--  -->
    <el-container class="el-container-vh" style="border: 1px solid #eee">
      <!-- 侧栏组件 -->
      <component :is="celan"></component>
      
      <el-container>
        <el-main>
          <el-table :data="tableData">
            <el-table-column align="center" width="111" prop="id" label="序号">
            </el-table-column>
            <el-table-column align="center" width="111" prop="payname" label="类型">
            </el-table-column>
            <el-table-column align="center" prop="img_url" label="图片RUL">
            </el-table-column>
            <el-table-column align="center" width="250" prop="device" label="设备号">
            </el-table-column>
            <!-- <el-table-column width="250" prop="beizhu" label="备注信息">
            </el-table-column> -->
            <el-table-column align="center" width="250" label="备注信息(按回车即可保存)">
              <template slot-scope="scope">
                  <el-input v-model="scope.row.beizhu" @keyup.enter.native="bianji(scope.row)">
                  </el-input>
              </template>
            </el-table-column> 

<!--             <el-table-column width="90">
              <template slot-scope="scope">
                  <el-button type="success" prop="id" @click="bianji(scope.row)">
                     编辑 
                  </el-button>
              </template>
            </el-table-column> -->
            <el-table-column width="100">
              <template slot-scope="scope">
                  <el-button type="danger" @click="del(scope.row.id)">
                    删除
                  </el-button>
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页 -->
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-size="8" 
            layout="total, prev, pager, next"
            :total="total">
          </el-pagination>

          </el-main>
      </el-container>
    </el-container>
</div>
</template>

<script>
//头部组件
import header_ from './header_.vue'
import celan from './celan.vue'
export default {
  name: 'header_',
   data() {
      return {
        tableData: null,
        total:null,
        header_:header_,
        celan:celan,
        imglist:'./login.php',
      }
    },
    methods: {
      //编辑备注
      bianji(row) {
          this.$http.post(this.imglist,{id:row.id,beizhu:row.beizhu},{emulateJSON:true}).then(res=>{
              if(res.body=='0'){
                  this.$notify({
                    title: '系统提示',
                    message: '修改成功',
                    type: 'success'
                  });
              }
          });
      },
      del(del_id){
          this.$http.post(this.imglist,{delimg:del_id},{emulateJSON:true}).then(res=>{
            this.tableData=res.body;
          });
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
      },
      handleCurrentChange(val) {

      }


    },
    created(){
      this.$http.post(this.imglist,{payimg:true},{emulateJSON:true}).then(res=>{
          this.tableData=res.body;
          // console.log(res.body)
      });
       
    }
}
</script>


<style scoped>
.el-container-vh{
  height: 100vh;
}
@media screen and (max-width: 800px) {
  .el-container-vh{
    height: 100%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/imglist.vue